import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgTeamDrawn = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 49,
	height: 48,
	viewBox: "0 0 49 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M30.9851 25.0653C38.7094 27.1354 42.6389 34.8991 42.5375 38.6997C41.7288 38.6997 16.1375 39.3739 13.0394 38.2953C11.823 29.6912 19.5401 26.0087 22.9866 25.0653C22.2263 25.0653 15.3202 10.1541 27.6364 10.1543C38.2639 10.1544 33.5447 20.6446 30.9851 25.0653Z",
			fill: "#FFD000"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29.1288 24.8152C36.853 26.8853 39.9205 33.8375 39.8191 37.6382C38.8852 38.0426 36.6197 38.2776 27.2359 38.6127C17.8521 38.9478 11.9313 38.2776 10.321 37.2338C9.10455 28.6297 17.7875 25.7586 21.234 24.8152C20.4737 24.8152 12.6017 9.09262 24.918 9.09277C35.5455 9.0929 31.6883 20.3945 29.1288 24.8152Z",
			stroke: "#1B1B20",
			strokeWidth: 2.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M33.0913 12.5454C34.7033 12.1222 37.4687 12.1635 38.4652 15.3419C39.7012 19.2842 36.5505 21.4986 35.7691 21.8521C37.5983 22.5174 43.1108 24.6361 42.9403 29.8758C41.1101 29.8758 39.1943 29.8758 38.4652 29.8758",
			stroke: "#1B1B20",
			strokeWidth: 2.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.9106 13.1536C14.9106 11.6536 12.2884 11.9726 11.0993 15.3413C9.70763 19.2836 12.1225 21.0428 13.0022 21.3962C10.9428 22.0616 5.86867 24.6355 6.06062 29.8752C6.52374 29.8752 9.93707 29.8752 11.0993 29.8752",
			stroke: "#1B1B20",
			strokeWidth: 2.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgTeamDrawn;
